import { render, staticRenderFns } from "./GpsCollectionPopup.vue?vue&type=template&id=1213a794&scoped=true&"
import script from "./GpsCollectionPopup.vue?vue&type=script&lang=js&"
export * from "./GpsCollectionPopup.vue?vue&type=script&lang=js&"
import style0 from "./GpsCollectionPopup.vue?vue&type=style&index=0&id=1213a794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213a794",
  null
  
)

export default component.exports